import {
  AdminPanelSettingsTwoTone,
  EmojiPeopleTwoTone,
  PersonTwoTone,
  SchoolTwoTone,
} from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { ElementType, MouseEvent } from 'react'

import { BreakpointName } from '@/types/mui'

import { languageConstants as LC } from '../../constants'
import useBreakpointName from '../../hooks/useBreakPointName'

const {
  USERROLE_ADMIN: ADMIN,
  USERROLE_COACH: COACH,
  USERROLE_GUEST: GUEST,
  USERROLE_USER: USER,
} = LC

type RoleValue = string

type RoleItem = {
  icon: ElementType
  title: string
  value: RoleValue
}

const data: RoleItem[] = [
  { icon: EmojiPeopleTwoTone, title: GUEST, value: 'guest' },
  { icon: PersonTwoTone, title: USER, value: 'user' },
  { icon: SchoolTwoTone, title: COACH, value: 'coach' },
  { icon: AdminPanelSettingsTwoTone, title: ADMIN, value: 'admin' },
]

type UserRoleSelectorProps = {
  onChange: (event: MouseEvent<HTMLElement>, newValue: RoleValue[]) => void
  value: RoleValue[]
}

export const UserRoleSelector = ({
  onChange,
  value,
  ...rest
}: UserRoleSelectorProps) => {
  const bpName: BreakpointName = useBreakpointName()
  const showTitle = bpName === 'xl' ? true : false

  const uiValue = value

  const handleChange = (
    event: MouseEvent<HTMLElement>,
    next: RoleValue[] | null
  ) => {
    onChange(event, next ?? [])
  }

  return (
    <ToggleButtonGroup
      value={uiValue}
      onChange={handleChange}
      exclusive={false}
      {...rest}
    >
      {data.map(role => {
        const Icon = role.icon

        return (
          <Tooltip arrow key={role.title} placement={'top'} title={role.title}>
            <ToggleButton value={role.value}>
              <Icon sx={{ mr: showTitle ? 1 : 0 }} />
              {showTitle && role.title}
            </ToggleButton>
          </Tooltip>
        )
      })}
    </ToggleButtonGroup>
  )
}
